import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import TopImageSection from '../../components/TopImageSection';

function BancoDeTalentosView() {
  const { t } = useTranslation();

  return (
    <>
      <TopImageSection
        imageURI={'https://images.pexels.com/photos/4050451/pexels-photo-4050451.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2'}
        padding={25}
        opacity={0.1}
      ></TopImageSection>

      <Container maxWidth="xl">
        <Box
          component={Card}
          mt={-30}
          mb={5}
          pt={5}
          borderRadius={5}
          sx={{
            position: 'relative',
            zIndex: 4
          }}
        >
          <CardHeader 
            title={t('jobs.bancodetalentos.title')} titleTypographyProps={{ variant: 'h3', fontWeight: 600}}
            sx={{ textAlign: 'center' }}
          ></CardHeader>

          <CardContent>
            <Box mx={4} my={2} alignContent={'center'} textAlign={'center'}>
              <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfvkx6Yz-sj1kQwQxv1x_sglIjbaUD1CGg0w9ASlnd4x_2sMg/formResponse?submit=Submit" width="100%" height="3072">Loading…</iframe>
            </Box>
          </CardContent>
        </Box>
      </Container>
    </>
  );
}

export default BancoDeTalentosView;
